// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7p-0";
export var optionCard = "_7p-1";